import { gql } from "@apollo/client";

export const GET_MOTIVO_CREDITICA = gql`
    query AllMotivosCrediticia{
        allMotivosCrediticia{
            motivoBloqueo
            idMotivoResolucionCrediticia
        }
    }
`;